var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"group"},[_c('label',[_vm._v("IP")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value.ip),expression:"value.ip"}],attrs:{"type":"text"},domProps:{"value":(_vm.value.ip)},on:{"input":function($event){if($event.target.composing)return;_vm.$set(_vm.value, "ip", $event.target.value)}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }